export type TrackingLocationHealth = 'live' | 'delayed' | 'stale' | 'ended'

interface GetLocationHealthStateInput {
  lastUpdatedSeconds: number | null
  status?: string | null
  endedStatuses?: string[]
}

export function getLocationHealthState({
  lastUpdatedSeconds,
  status,
  endedStatuses = ['delivered', 'cancelled', 'completed'],
}: GetLocationHealthStateInput): TrackingLocationHealth {
  if (status && endedStatuses.includes(status)) return 'ended'
  if (lastUpdatedSeconds == null) return 'stale'
  if (lastUpdatedSeconds <= 10) return 'live'
  if (lastUpdatedSeconds <= 60) return 'delayed'
  return 'stale'
}
